module.exports = __webpack_public_path__ + "img/category_34.815a9d36.png";